const services = {
	en: {
		dev: [
			{
				image: 'shopify',
				title: 'Shopify Development',
				intro: 'We create robust and scalable Shopify stores tailored to your business needs. Our experienced team ensures your store is not only visually appealing but also optimized for performance and user experience.',
				sublist: [
					'Custom Theme Development',
					'Responsive Design',
					'App Integration',
					'SEO Optimization',
					'Performance Optimization',
					'Ongoing Support',
				],
				url: '/services/shopify-development',
			},
			{
				image: 'shopify',
				title: 'Shopify Plus Development',
				intro: 'For high-growth enterprises seeking advanced e-commerce solutions, our Shopify Plus Development services offer unparalleled customization, scalability, and performance enhancements.',
				sublist: [
					'Advanced Customization',
					'Checkout Extensibility',
					'API Integration',
					'Internationalization',
					'B2B Functionality',
					'Launchpad Implementation',
				],
				url: '/services/shopify-plus',
			},
			{
				image: 'migration',
				title: 'Shopify Migration',
				intro: 'Here at Vevol Media, we love helping our clients migrate to Shopify. The migration process requires high levels of experience and care, and we make sure to make this process as smooth and efficient as possible for our clients.',
				sublist: ['text text text texta', 'text text text text', 'text text text text', 'text text text text'],
				url: '/services/shopify-migration',
			},
			{
				image: 'bespoke-dev',
				title: 'Shopify Apps Development',
				intro: `We develop Shopify apps that extend your store's functionality and automate business processes. Whether you need a private app for your store or a public app for the Shopify App Store, our team delivers scalable solutions.`,
				sublist: [
					'Custom App Development',
					'API Integration',
					'Process Automation',
					'Performance Optimization',
					'App Store Submission',
					'Ongoing Maintenance',
				],
				url: '/services/shopify-apps',
			},
			{
				image: 'bespoke-dev',
				title: 'eCommerce Mobile Apps',
				intro: 'Transform your Shopify store into a high-performance mobile app. Boost retention, conversions, and customer loyalty with custom iOS & Android apps built for speed, scalability, and seamless Shopify integration.',
				sublist: [
					'Custom App Development',
					'API Integration',
					'Process Automation',
				],
				url: '/services/ecommerce-mobile-app-development-for-shopify',
			}
		],
		ecommerce: [
			{
				image: 'cro',
				title: 'Conversion Rate Optimisation',
				intro: 'Getting traffic but low on sales? We will offer CRO services that will improve how users interact with your website. Audits, tracking, reports and implementation, all to increase conversion. ',
				sublist: ['text text text texta', 'text text text text', 'text text text text', 'text text text text'],
				url: '/services/conversion-rate-optimisation',
			},
			{
				image: 'seo',
				title: 'SEO Services',
				intro: "We will help analyse and optimise your company's Search Engine Optimisation using SEO metrics such as domain authority, inbound links, keyword rankings, monthly organic traffic, site speed, social sharing and more.",
				sublist: ['text text text texta', 'text text text text', 'text text text text', 'text text text text'],
				url: '/services/seo-services',
			},
			{
				image: 'seo',
				title: 'Free Shopify SEO Audit',
				intro: 'We offer a free SEO audit for all Shopify Plus & Shopify Advanced stores who use or plan to use our Shopify services.',
				sublist: ['text text text texta', 'text text text text', 'text text text text', 'text text text text'],
				url: '/services/shopify-seo-audit',
			},
			{
				image: 'uiuxdesign',
				title: 'UI/UX Web Design',
				intro: 'We specialise in conversion rate focused web design services: bespoke, responsive and inline with your branding and vision. Our UI/UX design team will turn any website into a brilliant one!',
				sublist: ['text text text texta', 'text text text text', 'text text text text', 'text text text text'],
				url: '/services/ui-ux-web-design',
			},
		],

	},
	ro: {
		dev: [
			{
				image: 'shopify',
				title: 'Dezvoltare Shopify',
				intro: 'Creăm magazine Shopify robuste și scalabile, adaptate nevoilor afacerii dumneavoastră. Echipa noastră de experți asigură că magazinul dumneavoastră nu este doar vizual atractiv, ci și optimizat pentru performanță și experiență de utilizare.',
				sublist: [
					'Dezvoltare temă personalizată',
					'Design responsive',
					'Integrare aplicații',
					'Optimizare SEO',
					'Optimizare performanță',
					'Suport continuu',
				],
				url: '/ro/servicii-shopify/dezvoltare-teme',
			},
			{
				image: 'shopify',
				title: 'Dezvoltare Shopify Plus',
				intro: 'Pentru companii în creștere care caută soluții eCommerce avansate, serviciile noastre de dezvoltare Shopify Plus oferă personalizare, scalabilitate și îmbunătățiri de performanță fără egal.',
				sublist: [
					'Personalizare avansată',
					'Extensibilitate checkout',
					'Integrare API',
					'Internationalizare',
					'Funcționalitate B2B',
					'Implementare Launchpad',
				],
				url: '/ro/servicii-shopify/shopify-plus',
			},
			{
				image: 'migration',
				title: 'Migrare Shopify',
				intro: 'Aici la Vevol Media, ne place să ajutăm clienții noștri să migreze la Shopify. Procesul de migrare necesită niveluri ridicate de experiență și grijă, și ne asigurăm că acest proces este cât mai smooth și eficient posibil pentru clienții noștri.',
				sublist: ['text text text texta', 'text text text text', 'text text text text', 'text text text text'],
				url: '/ro/servicii-shopify/migrari',
			},
			{
				image: 'bespoke-dev',
				title: 'Dezvoltare Aplicații Shopify',
				intro: `Dezvoltăm aplicații Shopify care extind funcționalitatea magazinului dumneavoastră și automatizează procesele afacerii. Fie că aveți nevoie de o aplicație privată pentru magazinul dumneavoastră, fie de o aplicație publică pentru magazinul din App Store Shopify, echipa noastră livrează soluții scalabile.`,
				sublist: [
					'Dezvoltare Aplicație Personalizată',
					'Integrare API',
					'Automatizare Procese',
					'Optimizare Performanță',
					'Submisie App Store',
					'Suport Continuu',
				],
				url: '/ro/servicii-shopify/aplicatii-si-integrari',
			},
		],
		ecommerce: [
			{
				image: 'cro',
				title: 'Optimizare Rate de Conversie',
				intro: 'Aveți trafic, dar puține vânzări? Vom oferi servicii de CRO care îmbunătățesc modul în care utilizatorii interacționează cu website-ul dumneavoastră. Audituri, urmărire, rapoarte și implementare, toate pentru a crește conversia. ',
				sublist: ['text text text texta', 'text text text text', 'text text text text', 'text text text text'],
				url: '/ro/servicii-shopify/cro-optimizare-rata-conversie',
			},
			{
				image: 'seo',
				title: 'Servicii SEO',
				intro: 'Vom ajuta să analizați și să optimizați Optimizarea Motorului de Căutare (SEO) a companiei dumneavoastră folosind metrici SEO precum autoritatea domeniului, link-uri de intrare, clasificările cuvinte-cheie, traficul organic lunar, viteza site-ului, partajarea socială și multe altele.',
				sublist: ['text text text texta', 'text text text text', 'text text text text', 'text text text text'],
				url: '/ro/servicii-shopify/seo',
			},
			{
				image: 'uiuxdesign',
				title: 'Design Web UI/UX',
				intro: 'Specializăm în servicii de design web focusate pe conversia ratei: bespoke, responsive și în conformitate cu branding-ul și viziunea dumneavoastră. Echipa noastră de design UI/UX va transforma orice website într-unul minunat!',
				sublist: ['text text text texta', 'text text text text', 'text text text text', 'text text text text'],
				url: '/ro/servicii-shopify/design-web',
			},
			{
				image: 'seo',
				title: 'Mentenanță și Suport',
				intro: 'Oferim planuri de mentenanță și suport. Acestea includ actualizări de teme, implementare de audite CRO, SEO, UI/UX, și multe altele. Specialiștii noștri Shopify sunt gata să vă ajute să vă asigurați că magazinul dumneavoastră este la cele mai înalte standarde de calitate.',
				sublist: ['Actualizări de teme', 'Implementare de audite CRO, SEO, UI/UX', 'Suport tehnic'],
				url: '/ro/servicii-shopify/mentenanta-si-suport',
			},
			{
				image: 'bespoke-dev',
				title: 'Aplicații mobile pentru eCommerce',
				intro: 'Dezvoltăm aplicații mobile pentru eCommerce Shopify care extind funcționalitatea magazinului dumneavoastră și automatizează procesele afacerii. Fie că aveți nevoie de o aplicație privată pentru magazinul dumneavoastră, fie de o aplicație publică pentru magazinul din App Store Shopify, echipa noastră livrează soluții scalabile.',
				sublist: [
					'Dezvoltare Aplicație Personalizată',
					'Integrare API',
					'Automatizare Procese',
				],
				url: '/ro/servicii-shopify/aplicatii-mobile',
			}
		],
	},
};

export default services;
